<template>
  <div>
    <div class="mainapply">
      <term-new :list="applylist" />
      <div class="color">
        <template v-for="(item,index) in formlist">
          <div class="apppadding" v-if="item.title != ''">
            <div class="title">{{item.title}}</div>
          </div>
          <div
            :class="['boxs', userInfoList[index].sex == '男' ? 'man' : 'girl' ]"
            v-if="userInfoList[index]"
          >
            <div class="box">
              <div class="boxmi">
                <div class="title">{{userInfoList[index].name}}</div>
                <div class="phone">{{userInfoList[index].mobile}}</div>
              </div>
              <div class="btnuse">
                <div class="btn">
                  <Button plain type="warning" @click="delUser(item,index)" size="mini" round>删除</Button>
                </div>
                <div class="btn">
                  <Button
                    plain
                    type="warning"
                    @click="upUser(userInfoList[index],index)"
                    size="mini"
                    round
                  >修改</Button>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="apppadding update">
            <Button plain type="warning" @click="updateUse(item,index)" size="large" round>添加参赛者</Button>
          </div>
        </template>
      </div>
    </div>

    <div class="footer apppadding">
      <div class="agree">
        <Checkbox v-model="show" shape="square" @change="onChange"></Checkbox>已阅读并同意
        <span @click="godisclaimer" style="color: #ff8c5f">《参赛声明》</span>
      </div>

      <Button
        :type="showtypesheet == true ? '':'warning'"
        :class="showtypesheet == true?'disbutton': ''"
        @click="signUp"
        size="large"
        round
        :disabled="showtypesheet"
      >确认</Button>
    </div>
  </div>
</template>

<script>
import "./apply.less";
import { matchinfo, typeattrtmpls } from "@/libs/api";
import { Button, Checkbox, Dialog } from "vant";
import TermNew from "@/components/termnew";
import { setStorage, getStorage } from "@/libs/utils";

export default {
  name: "mainapply",
  components: {
    Button,
    Checkbox,
    TermNew
  },
  data() {
    return {
      applylist: {},
      showtypesheet: true,
      radio: "0",
      show: false,
      userInfoList: [],
      formlist: [],
      postparams: {},
      matchid: "",
      typeid: "",
      urid: "",
      token: ""
    };
  },
  methods: {
    signUp: function() {
      this.$router.push({
        name: "order",
        params: {
          matchid: this.postparams.matchid,
          typeid: this.postparams.typeid,
          rgid: this.postparams.rgid,
          rrid: this.postparams.rrid
        }
      });
    },
    onChange(event) {
      this.show = event;
      let status = false;
      if (this.userInfoList.length > 0) {
        if (this.formlist.length == this.userInfoList.length) {
          this.userInfoList.forEach(item => {
            if (!item) {
              status = true;
            }
          });
        } else {
          status = true;
        }

        if (status == true) {
          this.showtypesheet = true;
        } else {
          this.showtypesheet = false;
        }
      } else {
        this.showtypesheet = true;
      }
    },
    updateUse(e, index) {
      this.$router.push({
        name: "userslist",
        params: {
          matchid: this.postparams.matchid,
          typeid: this.postparams.typeid,
          form: e,
          index: index
        }
      });
    },
    delUser(e, index) {
      Dialog.confirm({
        title: "提示",
        message: "确定删除该成员？"
      }).then(() => {
        var typeid = this.postparams.typeid;
        var membervalue = "membervalue" + typeid;
        try {
          var value = getStorage(membervalue);
          if (value) {
            value[index] = null;
            setStorage(membervalue, value, true);
            this.userInfoList = getStorage(membervalue);
            this.userInfoList.forEach(item => {
              if (item && item.list) {
                item.list.forEach(citem => {
                  if (citem.key_name == "mv_name") {
                    item.name = citem.value;
                  }
                  if (citem.key_name == "mv_mobile") {
                    item.mobile = citem.value;
                  }
                  if (citem.key_name == "mv_sex") {
                    item.sex = citem.value;
                  }
                });
              }
            });
          }
        } catch (e) {
          // console.log('')
        }
      });
    },
    upUser(e, index) {
      this.postparams.fromrole = 1;
      this.postparams.json = e;
      this.postparams.index = index;
      this.$router.push({
        name: "adduser",
        params: this.postparams,
        query: { rrid: this.postparams.rrid, rgid: this.postparams.rgid }
      });
    },
    getMatchInfo() {
      matchinfo({
        typeid: this.typeid,
        urid: this.urid,
        token: this.token,
        rgid: this.postparams.rgid,
        rrid: this.postparams.rrid
      }).then(res1 => {
        if (res1.status == 200) {
          this.applylist = res1.data;
        }
      });
    },
    typeAttrTmpls() {
      typeattrtmpls({
        matchid: this.matchid,
        typeid: this.typeid,
        urid: this.urid
      }).then(res => {
        if (res.status == 200) {
          res.data.list.forEach((item, index) => {
            if (item.amount > 1) {
              var title = item.title;
              for (var i = 1; i <= item.amount; i++) {
                item.title = title + i;
                item.aindex = index;
                this.formlist.push(JSON.stringify(item));
              }
            } else {
              item.aindex = index;
              this.formlist.push(JSON.stringify(item));
            }
          });
          this.formlist.forEach((item, index) => {
            this.formlist[index] = JSON.parse(item);
          });
        } else {
          this.formlist = [];
        }
      });
    },
    godisclaimer() {
      var src = escape(this.applylist.disclaimer);
      // console.log(this.applylist.disclaimer)
      // window.location.href = this.applylist.disclaimer
      this.$router.push({ name: "terms", params: { index: src } });
      // wx.navigateTo({
      //     url: '../../webview/index?src=' + src
      // })
    }
  },
  mounted() {
    this.$nextTick(() => {
      let param = this.$route.params
      let arr = Object.keys(param);
      if(param.rgid){
        if(arr.length == 0){
          this.postparams = getStorage('apply')
        }else{
          this.postparams = this.$route.params
          setStorage('apply',this.postparams,true)
        }
      }else{//防止跳转回来没有rgid
        this.postparams = getStorage('apply')
      }
      
      this.matchid = this.postparams.matchid;
      let userinfo = getStorage("userInfo");
      this.typeid = this.postparams.typeid;
      this.urid = userinfo.urid;
      this.token = userinfo.token;
      let membervalue = "membervalue" + this.typeid;
      this.getMatchInfo();
      this.typeAttrTmpls();
      if (membervalue) {
        this.show = false;
        if (getStorage(membervalue)) {
          this.userInfoList = getStorage(membervalue);
          this.userInfoList.forEach(item => {
            if (item && item.list) {
              item.list.forEach(citem => {
                if (citem.key_name == "mv_name") {
                  item.name = citem.value;
                }
                if (citem.key_name == "mv_mobile") {
                  item.mobile = citem.value;
                }
                if (citem.key_name == "mv_sex") {
                  item.sex = citem.value;
                }
              });
            }
          });
        }
      }
    });
  }
};
</script>